module.exports = __webpack_public_path__ + "img/step3.87b6ce49.png";